import { useEffect } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from '../utils/firebase'; // Assuming you create this file
import api from '../services/api';
import { useSelector } from 'react-redux';

export const useNotifications = () => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        // Register the service worker manually to handle sub-paths (GitHub Pages)
        const swUrl = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;
        const registration = await navigator.serviceWorker.register(swUrl);

        const token = await getToken(messaging, {
          vapidKey: 'BAAEKPv3SOdxrPkWcXKH20bMDxLbTA1Ylmvw06ega09o19CSB4Gbn_66N20QH9XzvVghMxa0-bq6uGRBS-VIgJY',
          serviceWorkerRegistration: registration
        });
        
        if (token) {
          // Send token to backend
          await api.post('/users/fcm-token', { token });
          console.log('FCM Token registered on backend:', token);
        }
      }
    } catch (error) {
      console.error('An error occurred while retrieving token:', error);
    }
  };

  useEffect(() => {
    if (isAuthenticated && user) {
      requestPermission();

      const unsubscribe = onMessage(messaging, (payload) => {
        console.log('Foreground message received:', payload);
        if ("Notification" in window) {
          const iconPath = `${window.location.origin}${process.env.PUBLIC_URL}/optimist_logo_192.png`;
          new Notification(payload.notification.title, {
            body: payload.notification.body,
            icon: iconPath
          });
        }
      });

      return () => unsubscribe();
    }
  }, [isAuthenticated, user]);
};
